import { useState } from "react";
import { Select, Space, Table, Tag, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import type { OutboundClick } from "@glow-price/shared";

import { channelsApi, outboundClicksApi } from "../api/resources";

const STATUS_OPTIONS = [
  { value: "pending", label: "pending" },
  { value: "success", label: "success" },
  { value: "failed", label: "failed" },
];

export function OutboundClicksPage() {
  const [channelId, setChannelId] = useState<string | undefined>();
  const [status, setStatus] = useState<string | undefined>();
  const [page, setPage] = useState(1);

  const channelsQuery = useQuery({
    queryKey: ["channels", "all"],
    queryFn: () => channelsApi.list({ page: 1, pageSize: 200 }),
  });
  const channelOptions = (channelsQuery.data?.items ?? []).map((c) => ({ value: c.id, label: c.name }));

  const list = useQuery({
    queryKey: ["outbound-clicks", channelId, status, page],
    queryFn: () => outboundClicksApi.list({ channelId, status, page, pageSize: 30 }),
  });

  return (
    <div>
      <Space style={{ marginBottom: 16, justifyContent: "space-between", width: "100%" }}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          导购点击记录
        </Typography.Title>
        <Space>
          <Select
            allowClear
            placeholder="渠道"
            options={channelOptions}
            value={channelId}
            onChange={(v) => {
              setPage(1);
              setChannelId(v);
            }}
            style={{ width: 200 }}
          />
          <Select
            allowClear
            placeholder="状态"
            options={STATUS_OPTIONS}
            value={status}
            onChange={(v) => {
              setPage(1);
              setStatus(v);
            }}
            style={{ width: 140 }}
          />
        </Space>
      </Space>

      <Table<OutboundClick>
        rowKey="id"
        loading={list.isLoading}
        dataSource={list.data?.items ?? []}
        pagination={{
          current: page,
          pageSize: 30,
          total: list.data?.total ?? 0,
          onChange: (p) => setPage(p),
          showSizeChanger: false,
        }}
        columns={[
          {
            title: "时间",
            dataIndex: "clickedAt",
            width: 160,
            render: (v) => dayjs(v).format("MM-DD HH:mm:ss"),
          },
          { title: "click_id", dataIndex: "clickId", width: 220 },
          {
            title: "渠道",
            dataIndex: "channelId",
            width: 140,
            render: (v) => channelOptions.find((o) => o.value === v)?.label ?? v,
          },
          { title: "标准商品", dataIndex: "standardProductId", width: 160 },
          { title: "渠道商品", dataIndex: "channelProductId", width: 160 },
          { title: "AppId", dataIndex: "appId", width: 140 },
          { title: "path", dataIndex: "path", ellipsis: true },
          { title: "场景", dataIndex: "scene", width: 110 },
          {
            title: "状态",
            dataIndex: "status",
            width: 100,
            render: (v) => {
              const color = v === "success" ? "green" : v === "failed" ? "red" : "default";
              return <Tag color={color}>{v}</Tag>;
            },
          },
          { title: "失败原因", dataIndex: "failureReason", ellipsis: true, width: 200 },
        ]}
      />
    </div>
  );
}
